import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import Typography from "@mui/material/Typography";
import DailyExpenseDayForm from "../components/DailyExpense/DailyExpenseDayForm";
import { API_DATE_FORMAT } from "../components/DailyExpense/constants";

/**
 * A path param is user-typed until proven otherwise. Round-tripping through the format rejects
 * "2026-13-40" as well as a day dayjs would silently reinterpret.
 */
const isBusinessDate = (value: string | undefined): value is string =>
  Boolean(value) && dayjs(value).isValid() && dayjs(value).format(API_DATE_FORMAT) === value;

export default function DailyExpenseFormPage() {
  const { date } = useParams<{ date: string }>();

  if (!isBusinessDate(date)) {
    return (
      <Typography color="text.secondary" fontWeight={500} sx={{ py: 2 }}>
        ลิงก์ไม่ถูกต้อง กรุณากลับไปเลือกวันจากรายการค่าใช้จ่ายรายวัน
      </Typography>
    );
  }
  return <DailyExpenseDayForm businessDate={date} />;
}
